var render = function () {
  var _vm$recruitment, _vm$recruitment2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "tit"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit grey-c--text"
  }, [_vm._v("채용관리")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "tit__line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(" " + _vm._s((_vm$recruitment = _vm.recruitment) === null || _vm$recruitment === void 0 ? void 0 : _vm$recruitment.subject) + " ")])])], 1)], 1), _c('template', {
    slot: "contents"
  }, [_c('v-row', {
    staticClass: "mb-n4 mb-md-12",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "align-md": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-badge', {
    staticClass: "v-badge--btn",
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow mr-4 mr-lg-8"
  }), _c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("채용 리스트")])])], 1)], 1), _c('v-col', {
    staticClass: "mb-12 mb-lg-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "end",
      "align-lg": "end"
    }
  }, [_c('v-col', {
    staticClass: "d-none d-lg-block"
  }, [_c('p', {
    staticClass: "page-text grey--text"
  }, [_vm._v("드래그하여 상태를 변경하세요.")])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": "auto"
    }
  }, [_c('meeting-view', {
    attrs: {
      "value": {
        recruitment: _vm.recruitment,
        applications: _vm.applications
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "w-100 w-lg-160px",
          attrs: {
            "outlined": "",
            "small": "",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v(" 전체항목 미팅요청 "), _c('v-icon', {
          staticClass: "ml-4",
          attrs: {
            "size": "18"
          }
        }, [_vm._v("mdi-calendar")])], 1)])];
      }
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": "auto"
    }
  }, [_c('texting-dialog', _vm._b({
    attrs: {
      "value": _vm.applications,
      "applications": _vm.applications,
      "paramsProps": {
        _recruitment: _vm._recruitment
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "w-100 w-lg-160px",
          attrs: {
            "outlined": "",
            "small": "",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v(" 전체항목 문자발송 "), _c('v-icon', {
          staticClass: "ml-4",
          attrs: {
            "size": "18"
          }
        }, [_vm._v("mdi-email-outline")])], 1)])];
      }
    }])
  }, 'texting-dialog', {
    recruitment: _vm.recruitment
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "lg": "auto"
    }
  }, [_c('application-excel-btn', {
    staticClass: "w-100 w-lg-160px",
    attrs: {
      "fileName": "".concat((_vm$recruitment2 = _vm.recruitment) === null || _vm$recruitment2 === void 0 ? void 0 : _vm$recruitment2.subject, "_\uC9C0\uC6D0\uC790_\uBAA9\uB85D"),
      "selected": _vm.applications,
      "small": "",
      "dark": "",
      "color": "green darken-3"
    }
  }, [_c('span', [_vm._v(" 엑셀파일 다운로드 "), _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-tray-arrow-down")])], 1)])], 1)], 1)], 1)], 1), _c('p', {
    staticClass: "text-right page-text--sm grey--text mb-4 d-lg-none",
    staticStyle: {
      "flex": "0 0 auto"
    }
  }, [_vm._v("상태값변경은 PC버전에서만 가능합니다.")]), _c('div', {
    staticClass: "kanban-item--groups"
  }, [_c('v-row', {
    staticClass: "row-cols-lg-5 row--small h-lg-100"
  }, _vm._l(_vm.fields, function (_ref3) {
    var _vm$recruitment3;
    var key = _ref3.value,
      text = _ref3.text,
      color = _ref3.color;
    return _c('v-col', {
      key: key,
      staticClass: "h-lg-100",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": ""
      }
    }, [_c('v-card', _vm._b({
      staticClass: "kanban-item--group fill-height",
      attrs: {
        "flat": "",
        "rounded": "",
        "dark": key == _vm.RECRUITMENT_KANBAN_FIELDS.REMOVED.value,
        "color": key == _vm.RECRUITMENT_KANBAN_FIELDS.REMOVED.value ? 'grey-5f' : 'grey-f1'
      }
    }, 'v-card', {
      loading: _vm.loading
    }, false), [_c('div', {
      staticClass: "px-10 py-20 pb-lg-60 fill-height d-flex flex-column"
    }, [_c('div', {
      staticClass: "mb-12",
      staticStyle: {
        "flex": "0 0 auto"
      }
    }, [_c('v-row', {
      staticClass: "row--small",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-layout', {
      attrs: {
        "align-center": ""
      }
    }, [_c('i', {
      class: 'mr-6 mr-lg-10 icon icon-dot icon-dot--' + color
    }), _c('p', {
      staticClass: "font-size-16 font-size-lg-18 font-weight-medium line-height-1"
    }, [_vm._v(" " + _vm._s(text) + " ")])])], 1), _c('v-spacer'), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "bottom": "",
        "nudge-bottom": "36"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref4) {
          var attrs = _ref4.attrs,
            on = _ref4.on;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": "",
              "text": "",
              "small": "",
              "color": key == _vm.RECRUITMENT_KANBAN_FIELDS.REMOVED.value ? 'white' : 'grey-13'
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_c('meeting-view', {
      attrs: {
        "value": {
          recruitment: _vm.recruitment,
          applications: _vm.stage[key]
        }
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref5) {
          var attrs = _ref5.attrs,
            on = _ref5.on;
          return [_c('v-list-item', _vm._g(_vm._b({
            attrs: {
              "outlined": "",
              "small": ""
            }
          }, 'v-list-item', attrs, false), on), [_c('v-list-item-icon', [_c('v-icon', {
            attrs: {
              "size": "18"
            }
          }, [_vm._v("mdi-calendar")])], 1), _c('v-list-item-title', [_vm._v(" 전체항목 미팅요청 ")])], 1)];
        }
      }], null, true)
    }), _c('texting-dialog', _vm._b({
      attrs: {
        "value": _vm.stage[key],
        "applications": _vm.applications,
        "paramsProps": {
          _recruitment: _vm._recruitment
        }
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref6) {
          var attrs = _ref6.attrs,
            on = _ref6.on;
          return [_c('v-list-item', _vm._g(_vm._b({
            attrs: {
              "outlined": "",
              "small": ""
            }
          }, 'v-list-item', attrs, false), on), [_c('v-list-item-icon', [_c('v-icon', {
            attrs: {
              "size": "18"
            }
          }, [_vm._v("mdi-email-outline")])], 1), _c('v-list-item-title', [_vm._v(" 전체항목 문자발송 ")])], 1)];
        }
      }], null, true)
    }, 'texting-dialog', {
      recruitment: _vm.recruitment
    }, false)), _c('application-excel-btn', {
      attrs: {
        "tag": "v-list-item",
        "fileName": "".concat((_vm$recruitment3 = _vm.recruitment) === null || _vm$recruitment3 === void 0 ? void 0 : _vm$recruitment3.subject, "_").concat(text, "_\uBAA9\uB85D"),
        "selected": _vm.stage[key],
        "dense": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-tray-arrow-down")])], 1), _c('v-list-item-title', [_vm._v(" 엑셀파일 다운로드 ")])], 1)], 1)], 1)], 1)], 1)], 1), _c('draggable', {
      staticClass: "kanban-items scroll-primary",
      attrs: {
        "draggable": ".kanban-item",
        "group": "application"
      },
      on: {
        "change": function change($event) {
          _vm.needsUpdate = true;
        }
      },
      model: {
        value: _vm.stage[key],
        callback: function callback($$v) {
          _vm.$set(_vm.stage, key, $$v);
        },
        expression: "stage[key]"
      }
    }, _vm._l(_vm.stage[key], function (item) {
      return _c('application-card', _vm._b({
        key: item === null || item === void 0 ? void 0 : item._id,
        staticClass: "kanban-item",
        attrs: {
          "value": item,
          "flat": "",
          "rounded": "lg"
        },
        on: {
          "input": _vm.search
        }
      }, 'application-card', {
        recruitment: _vm.recruitment
      }, false));
    }), 1)], 1)])], 1);
  }), 1)], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }